













































































































































import { Component, Vue } from 'vue-property-decorator';
import { 認証型 } from '@/type/authentication/authentication';
import {ValidationResult} from '@/type/validation/result';
import 新さっぽろ脳神経外科病院メーカー別集計表検索条件チェッカー from '@/type/custom/shinsapporo/report/新さっぽろ脳神経外科病院メーカー別集計表検索条件チェッカー';
import 新さっぽろ脳神経外科病院購入順位表検索条件チェッカー from '@/type/custom/shinsapporo/report/新さっぽろ脳神経外科病院購入順位表検索条件チェッカー';
import 新さっぽろ脳神経外科病院払出薬価順位表検索条件チェッカー from '@/type/custom/shinsapporo/report/新さっぽろ脳神経外科病院払出薬価順位表検索条件チェッカー';
import 新さっぽろ脳神経外科病院払出集計表検索条件チェッカー from '@/type/custom/shinsapporo/report/新さっぽろ脳神経外科病院払出集計表検索条件チェッカー';
import 新さっぽろ脳神経外科病院受払一覧表検索条件チェッカー from '@/type/custom/shinsapporo/report/新さっぽろ脳神経外科病院受払一覧表検索条件チェッカー';
import { progress } from '@/script/progress';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import Yearpicker from '@/components/datepicker/YearPicker.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import moment from 'moment';
import {loginModule} from '@/store/authentication/login';
import {部署型} from '@/type/custom/shinsapporo/report/部署型';
import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';

import {
  新さっぽろ脳神経外科病院メーカー別集計表出力条件型,
  新さっぽろ脳神経外科病院購入順位表出力条件型,
  新さっぽろ脳神経外科病院払出薬価順位表出力条件型,
  新さっぽろ脳神経外科病院払出集計表出力条件型,
  新さっぽろ脳神経外科病院受払一覧表出力条件型,
  在庫部署選択型,
} from '@/type/custom/shinsapporo/report/report';

@Component({
  components: {
    IconButton,
    ButtonPanel,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    Datepicker,
    Yearpicker,
    WholesaleSelector,
    DepartmentSelector,
    YearMonthPicker,
  },
})
export default class ReceiveDetail extends Vue {

  出力開始日付: Date | null = null;
  出力終了日付: Date | null = null;
  メーカー別集計表出力条件: 新さっぽろ脳神経外科病院メーカー別集計表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
    集計実績種別: '入庫実績',
  };
  購入順位表出力条件: 新さっぽろ脳神経外科病院購入順位表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
  };
  払出薬価順位表出力条件: 新さっぽろ脳神経外科病院払出薬価順位表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
  };
  払出集計表出力条件: 新さっぽろ脳神経外科病院払出集計表出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
  };
  受払一覧表出力条件: 新さっぽろ脳神経外科病院受払一覧表出力条件型 = {
    在庫年月: '',
    在庫場所: '',
  };
  在庫場所一覧: 部署型[] = [];
  アラートメッセージ: string | string[] | null = null;

  // computed
  get 所属部署コード(): string {
    return loginModule.部署コードを取得する;
  }

  created(): void {
    moment.locale('ja');
    this.initialize();
  }

  initialize() {
    const 終了日 = moment().startOf('month').add(-1).toDate();
    const 開始日 = moment(終了日).startOf('month').toDate();
    const 初期在庫年月 = moment().add(-1, 'month').format('YYYY-MM');
    this.メーカー別集計表出力条件 = {
      出力対象開始日: 開始日,
      出力対象終了日: 終了日,
      集計実績種別: '入庫実績',
    };
    this.購入順位表出力条件 = {
      出力対象開始日: 開始日,
      出力対象終了日: 終了日,
    };
    this.払出薬価順位表出力条件 = {
      出力対象開始日: 開始日,
      出力対象終了日: 終了日,
    };
    this.払出集計表出力条件 = {
      出力対象開始日: 開始日,
      出力対象終了日: 終了日,
    };
    this.受払一覧表出力条件 = {
      在庫年月: 初期在庫年月,
      在庫場所: '',
    };
  }

  download() {
    this.ダイアログを開く('新さっぽろ脳神経外科病院帳票ダウンロード確認ダイアログ');
  }

  clear() {
    this.出力開始日付 = null;
    this.出力終了日付 = null;
  }

  ダウンロードする() {
    this.ダイアログを閉じる('新さっぽろ脳神経外科病院帳票ダウンロード確認ダイアログ');
    // TODO: DL実装
  }

  ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  メーカー別集計表出力条件エラー判定(項目名: string): boolean {
    const checker = new 新さっぽろ脳神経外科病院メーカー別集計表検索条件チェッカー(this.メーカー別集計表出力条件);
    return checker.hasError(項目名);
  }

  async メーカー別集計表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.メーカー別集計表出力条件) {
      return;
    }
    const checker = new 新さっぽろ脳神経外科病院メーカー別集計表検索条件チェッカー(this.メーカー別集計表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('メーカー別集計表ダウンロード確認ダイアログ');
  }

  async メーカー別集計表を出力する(): Promise<void> {
    this.ダイアログを閉じる('メーカー別集計表ダウンロード確認ダイアログ');
    const now = new Date();
    if (this.メーカー別集計表出力条件.集計実績種別 === '入庫実績') {
      await download.新さっぽろ脳神経外科病院メーカー別集計表を出力する('メーカー別購入集計表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx',
            this.メーカー別集計表出力条件).catch(this.サーバリクエストエラートラップ);
    }
    if (this.メーカー別集計表出力条件.集計実績種別 === '払出実績') {
      await download.新さっぽろ脳神経外科病院メーカー別集計表を出力する('メーカー別払出集計表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx',
            this.メーカー別集計表出力条件).catch(this.サーバリクエストエラートラップ);
    }
  }

  async メーカー別集計表を出力するハンドラ(): Promise<void> {
    await progress(this.メーカー別集計表を出力する);
  }

  購入順位表出力条件エラー判定(項目名: string): boolean {
    const checker = new 新さっぽろ脳神経外科病院購入順位表検索条件チェッカー(this.購入順位表出力条件);
    return checker.hasError(項目名);
  }

  async 購入順位表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.購入順位表出力条件) {
      return;
    }
    const checker = new 新さっぽろ脳神経外科病院購入順位表検索条件チェッカー(this.購入順位表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('購入順位表ダウンロード確認ダイアログ');
  }

  async 購入順位表を出力する(): Promise<void> {
    this.ダイアログを閉じる('購入順位表ダウンロード確認ダイアログ');
    const now = new Date();
    await download.新さっぽろ脳神経外科病院購入順位表を出力する('購入順位表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.購入順位表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 購入順位表を出力するハンドラ(): Promise<void> {
    await progress(this.購入順位表を出力する);
  }

  払出薬価順位表出力条件エラー判定(項目名: string): boolean {
    const checker = new 新さっぽろ脳神経外科病院払出薬価順位表検索条件チェッカー(this.払出薬価順位表出力条件);
    return checker.hasError(項目名);
  }

  async 払出薬価順位表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.払出薬価順位表出力条件) {
      return;
    }
    const checker = new 新さっぽろ脳神経外科病院払出薬価順位表検索条件チェッカー(this.払出薬価順位表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('払出薬価順位表ダウンロード確認ダイアログ');
  }

  async 払出薬価順位表を出力する(): Promise<void> {
    this.ダイアログを閉じる('払出薬価順位表ダウンロード確認ダイアログ');
    const now = new Date();
    await download.新さっぽろ脳神経外科病院払出薬価順位表を出力する('払出薬価順位表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx',
          this.払出薬価順位表出力条件).catch(this.サーバリクエストエラートラップ);
  }

  async 払出薬価順位表を出力するハンドラ(): Promise<void> {
    await progress(this.払出薬価順位表を出力する);
  }

  払出集計表出力条件エラー判定(項目名: string): boolean {
    const checker = new 新さっぽろ脳神経外科病院払出集計表検索条件チェッカー(this.払出集計表出力条件);
    return checker.hasError(項目名);
  }

  async 払出集計表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.払出集計表出力条件) {
      return;
    }
    const checker = new 新さっぽろ脳神経外科病院払出薬価順位表検索条件チェッカー(this.払出集計表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('払出集計表ダウンロード確認ダイアログ');
  }

  async 払出集計表を出力する(): Promise<void> {
    this.ダイアログを閉じる('払出集計表ダウンロード確認ダイアログ');
    const now = new Date();
    await download.新さっぽろ脳神経外科病院払出集計表を出力する('払出集計表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.払出集計表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 払出集計表を出力するハンドラ(): Promise<void> {
    await progress(this.払出集計表を出力する);
  }

  受払一覧表出力条件エラー判定(項目名: string): boolean {
    const checker = new 新さっぽろ脳神経外科病院受払一覧表検索条件チェッカー(this.受払一覧表出力条件);
    return checker.hasError(項目名);
  }

  async 受払一覧表ダウンロード確認ダイアログを開く(): Promise<void> {
    if (!this.受払一覧表出力条件) {
      return;
    }
    const checker = new 新さっぽろ脳神経外科病院受払一覧表検索条件チェッカー(this.受払一覧表出力条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.ダイアログを開く('受払一覧表ダウンロード確認ダイアログ');
  }

  async 受払一覧表を出力する(): Promise<void> {
    this.ダイアログを閉じる('受払一覧表ダウンロード確認ダイアログ');
    const now = new Date();
    await download.新さっぽろ脳神経外科病院受払一覧表を出力する('受払一覧表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.受払一覧表出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  async 受払一覧表を出力するハンドラ(): Promise<void> {
    await progress(this.受払一覧表を出力する);
  }

  async mounted(): Promise<void> {
    await this.在庫場所一覧取得();
  }

  async 在庫場所一覧取得() {
    this.在庫場所一覧 = await api.新さっぽろ受払一覧表の在庫場所一覧を取得する();
    this.受払一覧表出力条件.在庫場所 = this.所属部署コード;
  }

  async サーバリクエストエラートラップ(error: any) {
    if (!error.data.errors) {
      this.showAlert(error.data.message);
    }
    if (error.data.errors) {
      this.showAlert(error.data.errors);
    }
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('新さっぽろ脳神経外科病院個別帳票出力アラート');
  }
}
